var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_801_424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_801_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9773 8.06136V5.99318H8.90909V5.03864H10.9773V2.97045H11.9318V5.03864H14V5.99318H11.9318V8.06136H10.9773ZM5.09091 6.77273C4.39091 6.77273 3.81818 6.55 3.37273 6.10455C2.92727 5.65909 2.70455 5.08636 2.70455 4.38636C2.70455 3.68636 2.92727 3.11364 3.37273 2.66818C3.81818 2.22273 4.39091 2 5.09091 2C5.79091 2 6.36364 2.22273 6.80909 2.66818C7.25455 3.11364 7.47727 3.68636 7.47727 4.38636C7.47727 5.08636 7.25455 5.65909 6.80909 6.10455C6.36364 6.55 5.79091 6.77273 5.09091 6.77273ZM0 11.8795V10.3841C0 10.0129 0.092803 9.67614 0.278409 9.37386C0.464015 9.07159 0.731818 8.84621 1.08182 8.69773C1.87727 8.34773 2.58437 8.10114 3.2031 7.95796C3.82185 7.81477 4.45026 7.74318 5.08833 7.74318C5.72641 7.74318 6.35303 7.81477 6.96818 7.95796C7.58333 8.10114 8.28864 8.34773 9.08409 8.69773C9.43409 8.85682 9.70455 9.08485 9.89545 9.38182C10.0864 9.67879 10.1818 10.0129 10.1818 10.3841V11.8795H0ZM0.954545 10.925H9.22727V10.3841C9.22727 10.2144 9.17955 10.0527 9.08409 9.89886C8.98864 9.74508 8.86136 9.63106 8.70227 9.55682C7.94924 9.20682 7.31288 8.97614 6.79318 8.86477C6.27348 8.75341 5.70606 8.69773 5.09091 8.69773C4.47576 8.69773 3.90568 8.75341 3.38068 8.86477C2.85568 8.97614 2.21667 9.20682 1.46364 9.55682C1.30455 9.63106 1.17992 9.74508 1.08977 9.89886C0.999621 10.0527 0.954545 10.2144 0.954545 10.3841V10.925ZM5.09091 5.81818C5.50455 5.81818 5.84659 5.68296 6.11705 5.4125C6.3875 5.14205 6.52273 4.8 6.52273 4.38636C6.52273 3.97273 6.3875 3.63068 6.11705 3.36023C5.84659 3.08977 5.50455 2.95455 5.09091 2.95455C4.67727 2.95455 4.33523 3.08977 4.06477 3.36023C3.79432 3.63068 3.65909 3.97273 3.65909 4.38636C3.65909 4.8 3.79432 5.14205 4.06477 5.4125C4.33523 5.68296 4.67727 5.81818 5.09091 5.81818Z",
    fill: "#E33AA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.25f36342aef294aac71ce45c0e4007b3.svg";
export { ForwardRef as ReactComponent };